import { Link } from 'react-router-dom';
import PageHero from '../components/ui/PageHero';
import { LuFileText, LuBookOpen, LuTriangleAlert, LuCopyright, LuMail, LuArrowLeft } from 'react-icons/lu';

const IMG = {
  hero: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=900&q=80&auto=format',
};

const SECTIONS = [
  {
    icon: <LuBookOpen size={22}/>,
    title: 'Use of This Website',
    content: [
      'KI INNOVATION is a free ki solution resource about airport baggage conveyor belt systems. You are welcome to read and share its content for personal, academic, or educational purposes.',
      'You must not use this website in any way that is unlawful, harmful, fraudulent, or that infringes on the rights of others.',
      'You must not attempt to gain unauthorised access to any part of this website or its underlying systems or servers.',
      'We reserve the right to restrict or terminate access to any user who violates these terms without prior notice.',
    ],
  },
  {
    icon: <LuCopyright size={22}/>,
    title: 'Intellectual Property',
    content: [
      'All original written content, design, layout, graphics, and code on this website is the property of KI INNOVATION and protected by copyright law.',
      'You may quote brief excerpts (no more than 100 words) for commentary or educational purposes, provided you clearly attribute KI INNOVATION and link back to the original page.',
      'You may not reproduce, republish, or redistribute substantial portions of our content without express written permission.',
      'Third-party images used on this site are sourced from Unsplash under their free-to-use licence. Attribution is provided where required.',
    ],
  },
  {
    icon: <LuTriangleAlert size={22}/>,
    title: 'Disclaimer of Warranties',
    content: [
      'All content on KI INNOVATION is provided for general informational and educational purposes only. It does not constitute professional engineering, technical, or legal advice.',
      'While we strive for accuracy, we make no warranties — express or implied — about the completeness, accuracy, or suitability of any information on this site.',
      'Aviation and baggage handling systems may vary significantly by airport, operator, and jurisdiction. Always consult official and authoritative industry sources for operational guidance.',
      'We are not liable for any losses, damages, or consequences arising from reliance on the information published on this website.',
    ],
  },
  {
    icon: <LuFileText size={22}/>,
    title: 'Links to External Websites',
    content: [
      'This site may contain links to external websites for further reading. These links are provided for convenience only.',
      'We have no control over, and accept no responsibility for, the content or privacy practices of any linked external sites.',
      'The inclusion of any external link does not imply our endorsement or approval of that site or its content.',
      'If you notice a broken or inappropriate link, please let us know via our Contact page.',
    ],
  },
];

function Terms() {
  return (
    <div className="page-enter">
      {/* Hero */}
      <PageHero
        tag="Legal"
        title="Terms of Use"
        subtitle="Please read these terms carefully before using the KI INNOVATION website. By accessing this site, you agree to be bound by them. Last updated: July 2026."
        breadcrumb={[{ label: 'Terms' }]}
      >
        <div className="page-hero-img-card">
          <img src={IMG.hero} alt="Legal documentation and terms of use" loading="lazy" />
        </div>
      </PageHero>

      {/* Content */}
      <section className="page-section bg-dark-2">
        <div className="container">
          <div className="legal-layout">

            {/* Sidebar */}
            <aside className="legal-sidebar">
              <div className="legal-sidebar-card">
                <div className="legal-sidebar-title">On This Page</div>
                <ul className="legal-sidebar-nav">
                  {SECTIONS.map((s,i) => (
                    <li key={i}>
                      <a href={`#section-${i}`} className="legal-sidebar-link">
                        <span style={{ color:'var(--primary)' }}>{s.icon}</span>
                        {s.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="legal-sidebar-contact">
                <LuMail size={16} style={{ color:'var(--primary)' }}/>
                <div>
                  <div style={{ fontWeight:700, fontSize:'.83rem', color:'var(--text-2)' }}>Questions?</div>
                  <a href="mailto:info@kiinnovation.in" style={{ fontSize:'.8rem', color:'var(--primary)' }}>
                    info@kiinnovation.in
                  </a>
                </div>
              </div>
            </aside>

            {/* Main */}
            <main className="legal-main">
              <div className="legal-intro">
                <p>
                  Welcome to KI INNOVATION. By accessing or using this website, you agree to be
                  bound by these Terms of Use. If you do not agree with any part of these terms,
                  please discontinue use of the website immediately. These terms may be updated
                  periodically; continued use constitutes acceptance of any changes.
                </p>
              </div>

              {SECTIONS.map((s,i) => (
                <div key={i} id={`section-${i}`} className="legal-section">
                  <div className="legal-section-header">
                    <span className="legal-section-icon">{s.icon}</span>
                    <h2 className="legal-section-title">{s.title}</h2>
                  </div>
                  <ul className="legal-list">
                    {s.content.map((item,j) => (
                      <li key={j}>{item}</li>
                    ))}
                  </ul>
                </div>
              ))}

              <div className="legal-section">
                <div className="legal-section-header">
                  <span className="legal-section-icon"><LuTriangleAlert size={22}/></span>
                  <h2 className="legal-section-title">Governing Law</h2>
                </div>
                <p className="legal-para">
                  These Terms of Use are governed by and construed in accordance with applicable law.
                  Any disputes arising from the use of this website shall be subject to the exclusive
                  jurisdiction of the relevant courts. If any provision of these terms is found
                  unenforceable, the remaining provisions shall remain in full force and effect.
                </p>
              </div>

              <div className="legal-back-row">
                <Link to="/" className="btn btn-ghost">
                  <LuArrowLeft size={16}/> Back to Home
                </Link>
                <Link to="/contact" className="btn btn-primary">
                  <LuMail size={16}/> Contact Us
                </Link>
              </div>
            </main>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Terms;
